import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('home');

  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/50">
      <div className="container-main py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {/* About */}
          <div className="md:col-span-1">
            <a href="/" className="inline-block mb-4">
              <span className="font-heading text-lg font-semibold text-foreground-900">
                AllChinaBuy<span className="text-primary-500">Spread</span>
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              {t('footer.about_desc')}
            </p>
            <p className="text-xs text-foreground-400">
              {t('footer.legal')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              {t('footer.links_title')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="/safety" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('footer.link_safety')}
                </a>
              </li>
              <li>
                <a href="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('footer.link_about')}
                </a>
              </li>
              <li>
                <a href="/contact" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('footer.link_contact')}
                </a>
              </li>
              <li>
                <a href="/disclaimer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('footer.link_disclaimer')}
                </a>
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              {t('cta.visit_main')}
            </h4>
            <p className="text-sm text-foreground-600 mb-4">
              {t('cta.ready_desc')}
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="btn-primary text-sm justify-center"
              >
                {t('cta.main_button')}
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="btn-secondary text-sm justify-center"
              >
                {t('cta.buy_now')}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-4">
            <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400">
              <i className="ri-shield-check-line text-accent-500" />
              {t('common.independent')}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}